'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgImage = function SvgImage(_ref) {
    var SvgSymbol = _ref.SvgSymbol,
        theme = _ref.theme,
        icon = _ref.icon,
        ariahidden = _ref.ariahidden;
    return _react2.default.createElement(SvgSymbol, {
        id: icon.name,
        icon: icon,
        arialabel: icon.label,
        theme: theme,
        ariahidden: ariahidden,
        render: function render() {
            return _react2.default.createElement(
                'symbol',
                { viewBox: icon.viewbox },
                _react2.default.createElement(
                    'desc',
                    null,
                    icon.label
                ),
                icon.shape
            );
        }
    });
};

SvgImage.propTypes = {
    ariahidden: _propTypes2.default.string,
    SvgSymbol: _propTypes2.default.element.isRequired,
    icon: _propTypes2.default.shape({
        shape: _propTypes2.default.node,
        label: _propTypes2.default.string,
        viewbox: _propTypes2.default.string
    }).isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string
    })
};

SvgImage.defaultProps = {
    ariahidden: 'true',
    theme: {}
};

var createSvgImage = function createSvgImage(SvgSymbol) {
    return function (props) {
        return SvgImage((0, _extends3.default)({ SvgSymbol: SvgSymbol }, props));
    };
};
exports.default = createSvgImage;
//# sourceMappingURL=createSvgImage.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/components/createSvgImage.js
 ** module id = 684
 ** module chunks = 1
 **/